import ScaleCalibrationView from
  '@/pages/_root/scale-calibration/ScaleCalibrationView';
import MapLayout from '@/templates/MapLayout';

export default [
  {
    path: '/dpc-calibration',
    name: 'dpcCalibration',
    component: ScaleCalibrationView,
    meta: {
      title: 'Calibrar PPC para Escalas',
      layout: MapLayout,
      primeIcon: 'calculator',
      isSlim: true,
    },
  },
];
